<template>
	<div class="drop-position" ref="config" :style="concludeWH">
		<vue-drag-resize
			class="mark-out-position"
			:class="canDrawRect ? 'pointer-none' : 'pointer-active'"
			v-for="(rectItem, rectIndex) in rectDetail"
			:key="rectIndex"
			:x="rectItem.areaMinX"
			:y="rectItem.areaMinY"
			:w="operateWidth(rectItem)"
			:h="operateHeight(rectItem)"
			:isActive="rectIndex === tempActiveArea"
			:isDraggable="rectIndex === tempActiveArea"
			:isResizable="rectIndex === tempActiveArea"
			@click.native="exitDrag"
			@resizestop="rectDragResize($event, rectIndex)"
			@dragstop="rectDragResize($event, rectIndex)"
		>
			<template>
				<div class="rect-title-wrap">
					<span class="big-num" v-if="JSON.parse(rectItem.remarks).cur">
						<span>[{{ JSON.parse(rectItem.appendInfo).paperRangeId }}]</span>
						<span> {{ JSON.parse(rectItem.remarks).bigNum }} </span>
						<span class="small-num"> ({{ `${JSON.parse(rectItem.remarks).cur | ''} / ${JSON.parse(rectItem.remarks).sum | ''}` }})</span>
					</span>
					<i class="iconfont iconlajitong1 del-icon" @click="dropArea({ val: rectItem, state: true })"></i>
					<div class="drop-menu">
						<el-dropdown class="el-dropdown-link" @command="dropDownMenu($event, { val: rectItem, curIndex: rectIndex })">
							<i class="iconfont iconjiantou-down "></i>
							<el-dropdown-menu slot="dropdown">
								<el-dropdown-item command="drag">拖拽选区</el-dropdown-item>
								<el-dropdown-item command="del">删除选区</el-dropdown-item>
							</el-dropdown-menu>
						</el-dropdown>
					</div>
				</div>
			</template>
		</vue-drag-resize>
	</div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import VueDragResize from 'vue-drag-resize'
import isDragResize from '@/views/template-configuration/utils/mixin/is-drag-resize'
import drawRect from '@/views/template-configuration/utils/mixin/draw-rect'
import fixWH from '@/views/template-configuration/utils/mixin/fix-wh'
import fixRect from '@/views/template-configuration/utils/mixin/fix-rect'

export default {
	name: 'subject',
	mixins: [isDragResize, drawRect, fixWH, fixRect],
	components: {
		VueDragResize
	},
	data() {
		return {
			//所有的框子
			rectDetail: [],
			//no use
			rectDetailInfo: {},
			query: this.$route.query,
			//类型
			emitType: 'tempRectSubjective',
			//no use
			preventMouseState: false
		}
	},
	watch: {
		//当前图片
		tempCurrentImgIndex: {
			handler() {
				this.fixCurrentSub(this.tempRectSubjective)
			},
			immediate: true
		},
		//所有主观题
		tempRectSubjective: {
			handler(val) {
				this.fixCurrentSub(val)
			},
			immediate: true
		}
	},
	computed: { ...mapGetters('examination/configation', ['tempRectSubjective']) },
	methods: {
		...mapActions('examination/databases', ['set', 'get']),
		...mapMutations('examination/configation', ['setTempActiveArea','setCanDrawRect']),
		//所有主观题
		async fixCurrentSub(val) {
			let bigNameList = {}
			val.forEach(res => {
				if (!bigNameList[JSON.parse(res.remarks).bigNum]) {
					bigNameList[JSON.parse(res.remarks).bigNum] = []
				}
				bigNameList[JSON.parse(res.remarks).bigNum].push(res)
			})

			for (let key in bigNameList) {
				bigNameList[key].forEach((res, index) => {
					let remarks = JSON.parse(res.remarks)
					remarks.sum = bigNameList[key].length
					remarks.cur = index + 1
					res.remarks = JSON.stringify(remarks)
				})
			}
			let resSubList = Object.values(bigNameList).flat(Infinity)
			this.rectDetail = []
			resSubList.forEach(resp => {
				if (resp.remarks && this.tempCurrentImgIndex.curIndex + 1 === Number(JSON.parse(resp.remarks).page)) {
					this.rectDetail.push(resp)
				}
			})
		},
		// 拖拽，缩放
		rectDragResize(newRect, index) {
			this.rectDetail[index].areaMinX = newRect.left
			this.rectDetail[index].areaMinY = newRect.top
			this.rectDetail[index].areaMaxX = newRect.left + newRect.width
			this.rectDetail[index].areaMaxY = newRect.top + newRect.height
			this.rectDetailInfo.subjective = this.rectDetail
			const params = {
				subjectId: this.query.subjectId,
				examId: this.query.examId,
				versionId: this.tempEditImgInfo.versionId,
				ppiId: this.rectDetail[index]['pkId'],
				ppiStr: JSON.stringify(this.rectDetail[index])
			}
			this.$post('Cv/refreshPpi', params).then(() => {
                this.$message.success('更新成功')
				this.setTempActiveArea(-1)
                this.setCanDrawRect(true)
			})
		}
	}
}
</script>

<style scoped lang="less">
@import '../utils/css/mark-point.less';
.big-num {
	font-size: 40px;
	color: red;
	font-weight: bolder;
}
.small-num {
	font-size: 40px;
	color: red;
	font-weight: bolder;
}
</style>
